import React from 'react';
import { useTranslations } from 'next-intl';
import { LinkButton } from '@/components/common/LinkButton';
import type { CurrentUserModel } from '@/core/models/CurrentUserModel';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';
import { EmbeddedApps } from '@/core/modules/EmbeddedApps';

interface SupplyChainMappingUrlLinkProps {
  value: string | null | undefined;
  className?: string;
}

export const SupplyChainMappingUrlLink: React.FC<SupplyChainMappingUrlLinkProps> = ({ value, className }) => {
  const t = useTranslations();
  const { user } = useCurrentUser();
  const url = getSupplyChainMappingUrl(value);

  if (!url) {
    return null;
  }

  return (
    <div className={className}>
      <LinkButton href={getHref(url, user)} target="_blank" color="primary">
        {t('explore-in-supply-chain-mapping')}
      </LinkButton>
    </div>
  );
};

function getSupplyChainMappingUrl(value: string | null | undefined) {
  if (!value?.trim()) return null;
  try {
    const url = new URL(value.trim());
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}

// Opens a registered embedded app's page with the link's hash as its deep link; otherwise the external URL.
function getHref(url: string, user: CurrentUserModel) {
  const match = EmbeddedApps.matchUrl(url);
  return match && user.isPageAvailable({ page: match.app.route }) ? `${match.app.route}${match.hash}` : url;
}
